<template >
    <v-dialog v-model="mostrar" fullscreen hide-overlay>
        <v-card>
            <v-toolbar  color="primary" dense fixed>
                <v-toolbar-title  @click="tipoRegistro='curso'" class=" d-none d-sm-flex maozinha display-1 white--text pl-4">{{curso.nome}} - {{aula.nome}}</v-toolbar-title>
                <v-toolbar-title  @click="tipoRegistro='curso'" class=" d-flex d-sm-none maozinha display-1 white--text pl-4">{{aula.nome}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn text color="white" @click="fechar()">Fechar</v-btn>
            </v-toolbar>
            <div class="fundo" fluid fill-height>
                <v-row no-gutters>
                    <v-col cols="12" class="col-lg-9 col-xl-8 conteudo" order-sm="1">
                        <Conteudo v-if="tipoRegistro=='aula'" :aula="aula" @aumentaAulasCompletas="aumentaAulasCompletas()" @diminuiAulasCompletas="diminuiAulasCompletas()" @aulaFinalizada="endered($event)"/>
                        <Transicao v-if="tipoRegistro == 'espera'"/>
                        <Inicial @acessarConteudo="abrirContent($event)" @cursoFinalizado="abrirFinalizacao($event)" :curso="curso" v-if="tipoRegistro=='curso'"/>
                        <Finalizacao @acessarConteudo="abrirContent($event)" v-if="tipoRegistro == 'finalizado'" :curso="curso" />
                        <div v-if="tipoRegistro=='finalizado'"></div>
                    
                        <v-container fluid v-if="tipoRegistro=='aula'">
                            <v-row no-gutters>
                                <v-col cols="12">
                                    <v-tabs background-color="transparent" v-model="tab">
                                        <v-tab class="d-flex d-lg-none" href="#conteudo">Conteudo</v-tab>
                                        <v-tab href="#perguntas">Perguntas</v-tab>
                                        <!-- <v-tab href="#recursos">Recursos</v-tab> -->
                                    </v-tabs>
                                    <v-tabs-items v-model="tab" class="lista" style="min-height: 100px; background-color: transparent;">
                                        <v-tab-item value="perguntas">
                                            <Perguntas :aula="aula"/>
                                        </v-tab-item>
                                        <v-tab-item value="conteudo" >
                                            <ListaConteudo class="d-flex d-lg-none" :curso="curso" @abrirAula="abrirContent($event)"/>
                                        </v-tab-item>
                                        <!-- <v-tab-item value="recursos">
                                            recursos
                                        </v-tab-item> -->
                                    </v-tabs-items>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-col>
                    <v-col cols="12" class="d-none d-lg-flex listaFlex col-lg-3 col-xl-4 mt-4 mt-sm-0 borda" order="2" order-sm="2">
                        <ListaConteudo :curso="curso" @abrirAula="abrirContent($event)"/>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapState} from 'vuex'
import axios from 'axios'
import { baseApiUrl, showError } from "@/config/global"
//import AulaVideo from "@/components/estudos/Cursos/AulaVideo"
import ListaConteudo from "@/components/estudos/Cursos/ListaConteudo"
import Conteudo from "@/components/estudos/Cursos/Conteudo"
import Inicial from '@/components/estudos/Cursos/Inicial'
import Transicao from '@/components/estudos/Cursos/Transicao'
import Finalizacao from '@/components/estudos/Cursos/Finalizacao'

import Perguntas from '@/components/estudos/Cursos/Perguntas'


//import pdf from 'vue-pdf'

export default {
    name: 'Curso',
    props:['mostrar', 'curso'],
    components:{ListaConteudo, Conteudo, Inicial, Transicao, Perguntas, Finalizacao},
    data(){
        return{
            tab: '',
            tipoRegistro: 'curso',
            aula: {},
            ativar: false,
            arquivoPdf: '',
            perguntas: {}
        }
    },
    computed:{
        ...mapState(['user']),

        conteudoTexto(){
            // return 
            if(this.aula.conteudo_texto != 'undefined' && this.aula.conteudo_texto != null){
                // return this.aula.conteudo_texto.replace('class="ql-align-center"', 'style="text-align: center;')
                return this.aula.conteudo_texto.replace('class="ql-align-center"', 'style="text-align: center;"')
            }
            else{
                return null
            }
            
        },

        url(){
            //return 'http://docs.google.com/gview?url=http://www.jlasistemas.com.br/arquivo/teste.pdf' + '&embedded=true'
            return 'https://drive.google.com/viewerng/viewer?embedded=true&url=http://www.jlasistemas.com.br/arquivos/teste.pdf'
        },

    },
    methods:{
        
        aumentaAulasCompletas(){
            this.$emit('aumentaAulasCompletas', this.curso.id)
        },

        diminuiAulasCompletas(){
            this.$emit('diminuiAulasCompletas', this.curso.id)
        },

        buscaPdf(){
            const url = `${baseApiUrl}/Estudos/Cursos/carregaPdf.php?url=${this.aula.url_texto}`    
            
            axios.get(url).then(res => {
                if(res.data.codigo == '01'){
                    this.arquivoPdf = 'data:application/pdf;base64,' + res.data.pdf64
                }else if(res.data.codigo != '05'){
                    showError(res.data.mensagem)
                }
            })
        },

        

        fechar(){
            this.aula = {}
            this.$emit('update:mostrar', false)
        },

        abrirContent(registro){
            if(registro.tipo == 'curso'){
                this.tipoRegistro = registro.tipo
            }else if(registro.tipo == 'aula'){
                this.perguntas = {}
                this.aula = registro
                this.mudarEtapa(registro.tipo)
                
            }
        },

        mudarEtapa(et){
            this.tipoRegistro = 'espera'
            let that = this
            this.tab = 'sobre'
            this.tituloNovaPergunta = ''
            this.textoNovaPergunta = ''
            this.novaPergunta = false
            setTimeout(()=>{
                that.tipoRegistro = et
                // if(that.aula.tipo_aula == 'T'){
                //     that.buscaPdf()
                // }
            }, 1000)
        },

        endered(){
            
            let proximaAula = false

             for(let m = 0; m < this.curso.modulos.length; m++){
                 if(!proximaAula){
                     for(let a = 0; a < this.curso.modulos[m].aulas.length; a++){
                         if(!this.curso.modulos[m].aulas[a].concluida){
                             
                             this.aula = this.curso.modulos[m].aulas[a]
                             proximaAula = true
                             break
                         }
                     }
                 }else{
                     break
                 }
            }
            
            if(proximaAula){
                 this.mudarEtapa("aula")
            }else{
                 this.mudarEtapa("finalizado")
            }
        }

        
    },

    watch:{
        mostrar(val){
            if(val){
                this.tipoRegistro = 'curso'
            }
        }
    }
}
</script>

<style scoped>

.conteudo{
    height: calc(100vh - 84px);
    overflow-y: auto;
}


.fundo{
    background-color: rgba(220, 220, 255, 0.5);
}

.maozinha{
    cursor: pointer;
}


.tamanhoMax80{
    height: 88vh;
    overflow-y: auto
}

.tituloDescricao{
    margin-bottom: 10px;
}

.avtPergunta{
    display: block;
}

.elResposta{
    display: inline;
    margin-left: 30px;
}

.divResposta{
    margin-top: 30px;
}

.listaFlex{
    flex-direction: column;
    max-height: calc(100vh - 84px);
    overflow-y: auto;
}

.lista{
    background-color: red;
}

.borda{
    border-left: 1px rgba(220, 220, 255, 1) solid;
}
</style>